module.exports = __webpack_public_path__ + "client/img/invest_01.6a8c4ea6.png";